"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageData = /** @class */ (function () {
    function PageData(URL, PageName, Component) {
        if (URL === void 0) { URL = ''; }
        if (PageName === void 0) { PageName = ''; }
        this.url = URL;
        this.pageName = PageName;
        this.component = Component;
        this.pageData = {};
    }
    return PageData;
}());
exports.default = PageData;
//# sourceMappingURL=PageData.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/framework/pageManager/PageData.js
// module id = 36
// module chunks = 0